var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-107"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.47,245.92s-6.72,4.09-7.3,14.6,1.75,37.66,3.21,42,8.76,8.76,14.31,7.59c0,0,2.33,25.7,5,25.11s16.35-19,16.93-24.23S322,288.84,322,288.84a185.5,185.5,0,0,0,2-23.94c0-10.8-2.63-19.56-12-22.78S294.89,241.25,288.47,245.92Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Page--inject-107"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.54,
    y: 97,
    width: 325.22,
    height: 269.48,
    style: {
      fill: "#3FB9EA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.54,
    y: 97,
    width: 325.22,
    height: 269.48,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.36,
    y: 145.99,
    width: 303.14,
    height: 137.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.96,
    y1: 264.13,
    x2: 383.35,
    y2: 264.13,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.96,
    y1: 264.13,
    x2: 100.96,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.83,
    y1: 264.13,
    x2: 115.83,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.69,
    y1: 264.13,
    x2: 130.69,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.55,
    y1: 264.13,
    x2: 145.55,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.41,
    y1: 264.13,
    x2: 160.41,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.27,
    y1: 264.13,
    x2: 175.27,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.14,
    y1: 264.13,
    x2: 190.14,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205,
    y1: 264.13,
    x2: 205,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 219.86,
    y1: 264.13,
    x2: 219.86,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.72,
    y1: 264.13,
    x2: 234.72,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.59,
    y1: 264.13,
    x2: 249.59,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.45,
    y1: 264.13,
    x2: 264.45,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.31,
    y1: 264.13,
    x2: 279.31,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.17,
    y1: 264.13,
    x2: 294.17,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.04,
    y1: 264.13,
    x2: 309.04,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 323.9,
    y1: 264.13,
    x2: 323.9,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 338.76,
    y1: 264.13,
    x2: 338.76,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 353.62,
    y1: 264.13,
    x2: 353.62,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.49,
    y1: 264.13,
    x2: 368.49,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.35,
    y1: 264.13,
    x2: 383.35,
    y2: 261.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.96,
    y1: 264.13,
    x2: 100.96,
    y2: 153.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.96,
    y1: 264.13,
    x2: 108.02,
    y2: 264.13,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.96,
    y1: 241.97,
    x2: 93.17,
    y2: 241.97,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.96,
    y1: 219.82,
    x2: 93.17,
    y2: 219.82,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.96,
    y1: 197.67,
    x2: 93.17,
    y2: 197.67,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.96,
    y1: 175.52,
    x2: 93.17,
    y2: 175.52,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.96,
    y1: 153.36,
    x2: 93.17,
    y2: 153.36,
    style: {
      fill: "none",
      stroke: "#8c8c8c",
      strokeMiterlimit: 10,
      strokeWidth: "0.5370410680770874px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.26,
    y1: 175.52,
    x2: 108.39,
    y2: 241.97,
    style: {
      fill: "none",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.1481642723083496px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.12,
    y1: 213.18,
    x2: 123.26,
    y2: 175.52,
    style: {
      fill: "none",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.1481642723083496px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.98,
    y1: 197.67,
    x2: 138.12,
    y2: 213.18,
    style: {
      fill: "none",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.1481642723083496px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.84,
    y1: 237.54,
    x2: 152.98,
    y2: 197.67,
    style: {
      fill: "none",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.1481642723083496px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.71,
    y1: 175.52,
    x2: 167.84,
    y2: 237.54,
    style: {
      fill: "none",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.1481642723083496px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.57,
    y1: 153.36,
    x2: 182.71,
    y2: 175.52,
    style: {
      fill: "none",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.1481642723083496px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.43,
    y1: 253.05,
    x2: 197.57,
    y2: 153.36,
    style: {
      fill: "none",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.1481642723083496px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.29,
    y1: 246.41,
    x2: 212.43,
    y2: 253.05,
    style: {
      fill: "none",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.1481642723083496px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.16,
    y1: 244.19,
    x2: 227.29,
    y2: 246.41,
    style: {
      fill: "none",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.1481642723083496px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.02,
    y1: 237.54,
    x2: 242.16,
    y2: 244.19,
    style: {
      fill: "none",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.1481642723083496px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.88,
    y1: 228.68,
    x2: 257.02,
    y2: 237.54,
    style: {
      fill: "none",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.1481642723083496px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 286.74,
    y1: 233.11,
    x2: 271.88,
    y2: 228.68,
    style: {
      fill: "none",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.1481642723083496px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.6,
    y1: 241.97,
    x2: 286.74,
    y2: 233.11,
    style: {
      fill: "none",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.1481642723083496px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.47,
    y1: 195.45,
    x2: 301.6,
    y2: 241.97,
    style: {
      fill: "none",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.1481642723083496px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.33,
    y1: 188.81,
    x2: 316.47,
    y2: 195.45,
    style: {
      fill: "none",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.1481642723083496px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 346.19,
    y1: 179.95,
    x2: 331.33,
    y2: 188.81,
    style: {
      fill: "none",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.1481642723083496px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.05,
    y1: 188.81,
    x2: 346.19,
    y2: 179.95,
    style: {
      fill: "none",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.1481642723083496px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.92,
    y1: 197.67,
    x2: 361.05,
    y2: 188.81,
    style: {
      fill: "none",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.1481642723083496px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.39,239.35h0A2.62,2.62,0,0,1,111,242h0a2.63,2.63,0,0,1-2.63,2.63h0a2.62,2.62,0,0,1-2.62-2.63h0A2.62,2.62,0,0,1,108.39,239.35Z",
    style: {
      fill: "#fff",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.26,172.89h0a2.62,2.62,0,0,1,2.62,2.63h0a2.62,2.62,0,0,1-2.62,2.62h0a2.62,2.62,0,0,1-2.63-2.62h0A2.63,2.63,0,0,1,123.26,172.89Z",
    style: {
      fill: "#fff",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.12,210.55h0a2.63,2.63,0,0,1,2.63,2.63h0a2.62,2.62,0,0,1-2.63,2.62h0a2.62,2.62,0,0,1-2.63-2.62h0A2.63,2.63,0,0,1,138.12,210.55Z",
    style: {
      fill: "#fff",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,195h0a2.63,2.63,0,0,1,2.63,2.63h0A2.63,2.63,0,0,1,153,200.3h0a2.63,2.63,0,0,1-2.63-2.63h0A2.63,2.63,0,0,1,153,195Z",
    style: {
      fill: "#fff",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.84,234.92h0a2.62,2.62,0,0,1,2.63,2.62h0a2.63,2.63,0,0,1-2.63,2.63h0a2.62,2.62,0,0,1-2.62-2.63h0A2.62,2.62,0,0,1,167.84,234.92Z",
    style: {
      fill: "#fff",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.71,172.89h0a2.62,2.62,0,0,1,2.62,2.63h0a2.62,2.62,0,0,1-2.62,2.62h0a2.62,2.62,0,0,1-2.63-2.62h0A2.63,2.63,0,0,1,182.71,172.89Z",
    style: {
      fill: "#fff",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.57,150.74h0a2.62,2.62,0,0,1,2.63,2.62h0a2.63,2.63,0,0,1-2.63,2.63h0a2.63,2.63,0,0,1-2.63-2.63h0A2.62,2.62,0,0,1,197.57,150.74Z",
    style: {
      fill: "#263238",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.43,250.42h0a2.63,2.63,0,0,1,2.63,2.63h0a2.63,2.63,0,0,1-2.63,2.63h0a2.63,2.63,0,0,1-2.63-2.63h0A2.63,2.63,0,0,1,212.43,250.42Z",
    style: {
      fill: "#fff",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.29,243.78h0a2.63,2.63,0,0,1,2.63,2.63h0a2.62,2.62,0,0,1-2.63,2.62h0a2.62,2.62,0,0,1-2.62-2.62h0A2.62,2.62,0,0,1,227.29,243.78Z",
    style: {
      fill: "#fff",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.16,241.56h0a2.62,2.62,0,0,1,2.62,2.63h0a2.62,2.62,0,0,1-2.62,2.63h0a2.63,2.63,0,0,1-2.63-2.63h0A2.63,2.63,0,0,1,242.16,241.56Z",
    style: {
      fill: "#fff",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,234.92h0a2.62,2.62,0,0,1,2.62,2.62h0a2.62,2.62,0,0,1-2.62,2.63h0a2.63,2.63,0,0,1-2.63-2.63h0A2.62,2.62,0,0,1,257,234.92Z",
    style: {
      fill: "#fff",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.88,226.06h0a2.62,2.62,0,0,1,2.63,2.62h0a2.63,2.63,0,0,1-2.63,2.63h0a2.63,2.63,0,0,1-2.63-2.63h0A2.62,2.62,0,0,1,271.88,226.06Z",
    style: {
      fill: "#fff",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.74,230.49h0a2.62,2.62,0,0,1,2.63,2.62h0a2.63,2.63,0,0,1-2.63,2.63h0a2.62,2.62,0,0,1-2.62-2.63h0A2.62,2.62,0,0,1,286.74,230.49Z",
    style: {
      fill: "#fff",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.6,239.35h0a2.62,2.62,0,0,1,2.63,2.62h0a2.62,2.62,0,0,1-2.63,2.63h0A2.62,2.62,0,0,1,299,242h0A2.62,2.62,0,0,1,301.6,239.35Z",
    style: {
      fill: "#fff",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.47,192.83h0a2.62,2.62,0,0,1,2.62,2.62h0a2.62,2.62,0,0,1-2.62,2.63h0a2.63,2.63,0,0,1-2.63-2.63h0A2.62,2.62,0,0,1,316.47,192.83Z",
    style: {
      fill: "#fff",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.33,186.18h0a2.63,2.63,0,0,1,2.63,2.63h0a2.62,2.62,0,0,1-2.63,2.62h0a2.62,2.62,0,0,1-2.63-2.62h0A2.63,2.63,0,0,1,331.33,186.18Z",
    style: {
      fill: "#fff",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.19,177.32h0a2.63,2.63,0,0,1,2.63,2.63h0a2.62,2.62,0,0,1-2.63,2.62h0a2.62,2.62,0,0,1-2.62-2.62h0A2.62,2.62,0,0,1,346.19,177.32Z",
    style: {
      fill: "#fff",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.05,186.18h0a2.63,2.63,0,0,1,2.63,2.63h0a2.62,2.62,0,0,1-2.63,2.62h0a2.62,2.62,0,0,1-2.62-2.62h0A2.62,2.62,0,0,1,361.05,186.18Z",
    style: {
      fill: "#fff",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.92,195h0a2.62,2.62,0,0,1,2.62,2.63h0a2.62,2.62,0,0,1-2.62,2.63h0a2.63,2.63,0,0,1-2.63-2.63h0A2.63,2.63,0,0,1,375.92,195Z",
    style: {
      fill: "#fff",
      stroke: "#3FB9EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.35,
    y: 97,
    width: 8.4,
    height: 269.48,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.35,
    y: 130.24,
    width: 8.4,
    height: 68.64,
    style: {
      fill: "#878787"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.54,
    y: 97,
    width: 325.22,
    height: 16.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.54,118.51H165a2,2,0,0,1,2,2v9.2a2,2,0,0,1-2,2H83.54a0,0,0,0,1,0,0V118.51A0,0,0,0,1,83.54,118.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.61,126.14l.87-5.72h1.76v8H98V122.7l-.87,5.77H96L95,122.78v5.69H93.92v-8h1.76Z",
    style: {
      fill: "#3FB9EA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.26,128.47H103l-.22-1.46h-1.55l-.22,1.46H99.83l1.29-8H103Zm-2.89-2.55h1.22l-.61-4.07Z",
    style: {
      fill: "#3FB9EA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.49,128.47a2.46,2.46,0,0,1-.11-1v-1.26c0-.75-.26-1-.83-1h-.44v3.28h-1.26v-8h1.91c1.31,0,1.87.61,1.87,1.85v.64a1.6,1.6,0,0,1-.83,1.63c.63.26.84.87.84,1.71v1.25a2.28,2.28,0,0,0,.14,1Zm-1.38-6.9V124h.5c.47,0,.75-.2.75-.85v-.79c0-.58-.19-.83-.64-.83Z",
    style: {
      fill: "#3FB9EA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.14,125.47v1.07c0,1.29-.64,2-1.88,2s-1.89-.74-1.89-2v-4.19c0-1.29.64-2,1.89-2s1.88.73,1.88,2v.79H112v-.87c0-.57-.26-.79-.66-.79s-.66.22-.66.79v4.35c0,.58.26.78.66.78s.66-.2.66-.78v-1.15Z",
    style: {
      fill: "#3FB9EA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.18,128.47h-1.26v-8h1.26v3.45h1.44v-3.45h1.29v8h-1.29V125h-1.44Z",
    style: {
      fill: "#3FB9EA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.93,
    y: 99.81,
    width: 209.09,
    height: 9.31,
    style: {
      fill: "#ededed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.13,
    y: 267.17,
    width: 14.15,
    height: 6.5,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.01,
    y: 267.17,
    width: 14.15,
    height: 6.5,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.89,
    y: 267.17,
    width: 14.15,
    height: 6.5,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.77,
    y: 267.17,
    width: 14.15,
    height: 6.5,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.65,
    y: 267.17,
    width: 14.15,
    height: 6.5,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.53,
    y: 267.17,
    width: 14.15,
    height: 6.5,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.41,
    y: 267.17,
    width: 14.15,
    height: 6.5,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.29,
    y: 267.17,
    width: 14.15,
    height: 6.5,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.17,
    y: 267.17,
    width: 14.15,
    height: 6.5,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.05,
    y: 267.17,
    width: 14.15,
    height: 6.5,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.93,
    y: 267.17,
    width: 14.15,
    height: 6.5,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.81,
    y: 267.17,
    width: 14.15,
    height: 6.5,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.69,
    y: 267.17,
    width: 14.15,
    height: 6.5,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.57,
    y: 267.17,
    width: 14.15,
    height: 6.5,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.45,
    y: 267.17,
    width: 14.15,
    height: 6.5,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.33,
    y: 267.17,
    width: 14.15,
    height: 6.5,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.21,
    y: 267.17,
    width: 14.15,
    height: 6.5,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.1,
    y: 267.17,
    width: 14.15,
    height: 6.5,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.98,
    y: 267.17,
    width: 14.15,
    height: 6.5,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.93,
    y: 137.02,
    width: 24.1,
    height: 6.5,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.27,
    y: 137.02,
    width: 24.1,
    height: 6.5,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.62,
    y: 137.02,
    width: 24.1,
    height: 6.5,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.96,
    y: 137.02,
    width: 24.1,
    height: 6.5,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.31,
    y: 137.02,
    width: 24.1,
    height: 6.5,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.66,
    y: 137.02,
    width: 24.1,
    height: 6.5,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 137.02,
    width: 24.1,
    height: 6.5,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.35,
    y: 137.02,
    width: 24.1,
    height: 6.5,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.69,
    y: 137.02,
    width: 24.1,
    height: 6.5,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.04,
    y: 137.02,
    width: 24.1,
    height: 6.5,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.39,
    y: 137.02,
    width: 24.1,
    height: 6.5,
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.73,
    y: 137.02,
    width: 24.1,
    height: 6.5,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,152.37H203.22l8.9,4.45v9.09a2.41,2.41,0,0,0,2.41,2.41H242a2.41,2.41,0,0,0,2.41-2.41V154.78A2.41,2.41,0,0,0,242,152.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.54,157.61c0-.92-.33-1.17-.84-1.17s-.84.28-.84,1v.66h-1.53v-.56c0-1.64.82-2.58,2.41-2.58s2.41.94,2.41,2.58v.27a2,2,0,0,1-1.13,2.11,2.1,2.1,0,0,1,1.13,2.16v.81c0,1.65-.82,2.59-2.41,2.59s-2.41-.94-2.41-2.59v-.85h1.53V163c0,.74.32,1,.84,1s.84-.25.84-1.16v-.81c0-1-.33-1.31-1.06-1.31h-.55v-1.47h.64c.6,0,1-.26,1-1.09Z",
    style: {
      fill: "#3FB9EA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.11,157.55a2.45,2.45,0,1,1,4.9,0v5.35a2.45,2.45,0,1,1-4.9,0Zm1.61,5.45c0,.74.33,1,.84,1s.84-.28.84-1v-5.55c0-.73-.33-1-.84-1s-.84.28-.84,1Z",
    style: {
      fill: "#3FB9EA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.17,161.27l-.5.94v3.16h-1.61V155.08h1.61v4.49l2.12-4.49h1.61l-2.24,4.59,2.24,5.7h-1.66Z",
    style: {
      fill: "#3FB9EA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,313.15v1.1c0,.84.37,1.14,1,1.14s1-.3,1-1.14v-2.6c0-.84-.37-1.16-1-1.16s-1,.32-1,1.16V312h-1.75l.34-6.85h4.89v1.68h-3.22l-.16,2.82a1.77,1.77,0,0,1,1.62-.86c1.37,0,2.06,1,2.06,2.7v2.63c0,1.89-.94,3-2.76,3s-2.77-1.08-2.77-3v-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.87,308c0-1.89,1-3,2.82-3s2.82,1.08,2.82,3v6.14c0,1.89-1,3-2.82,3s-2.82-1.08-2.82-3Zm1.86,6.26c0,.84.37,1.16,1,1.16s1-.32,1-1.16v-6.38c0-.84-.37-1.16-1-1.16s-1,.32-1,1.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.56,308c0-1.89,1-3,2.81-3s2.82,1.08,2.82,3v6.14c0,1.89-1,3-2.82,3s-2.81-1.08-2.81-3Zm1.85,6.26c0,.84.37,1.16,1,1.16s1-.32,1-1.16v-6.38c0-.84-.37-1.16-1-1.16s-1,.32-1,1.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.82,312.26l-.58,1.08V317h-1.85v-11.8h1.85v5.14l2.43-5.14h1.86L149,310.42l2.58,6.54h-1.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.66,
    y1: 325.22,
    x2: 151.71,
    y2: 325.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.58,313.15v1.1c0,.84.37,1.14,1,1.14s1-.3,1-1.14v-2.6c0-.84-.37-1.16-1-1.16s-1,.32-1,1.16V312h-1.76l.34-6.85h4.89v1.68h-3.22l-.15,2.82a1.76,1.76,0,0,1,1.62-.86c1.36,0,2,1,2,2.7v2.63c0,1.89-.94,3-2.76,3s-2.77-1.08-2.77-3v-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.44,308c0-1.89,1-3,2.81-3s2.82,1.08,2.82,3v6.14c0,1.89-1,3-2.82,3s-2.81-1.08-2.81-3Zm1.85,6.26c0,.84.37,1.16,1,1.16s1-.32,1-1.16v-6.38c0-.84-.37-1.16-1-1.16s-1,.32-1,1.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.12,308c0-1.89,1-3,2.81-3s2.82,1.08,2.82,3v6.14c0,1.89-1,3-2.82,3s-2.81-1.08-2.81-3Zm1.85,6.26c0,.84.37,1.16,1,1.16s1-.32,1-1.16v-6.38c0-.84-.37-1.16-1-1.16s-1,.32-1,1.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.38,312.26l-.58,1.08V317H247v-11.8h1.85v5.14l2.43-5.14h1.86l-2.58,5.26,2.58,6.54h-1.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.22,
    y1: 325.22,
    x2: 253.27,
    y2: 325.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.85,313.15v1.1c0,.84.37,1.14,1,1.14s1-.3,1-1.14v-2.6c0-.84-.37-1.16-1-1.16s-1,.32-1,1.16V312H337.1l.33-6.85h4.9v1.68H339.1l-.15,2.82a1.77,1.77,0,0,1,1.62-.86c1.37,0,2.06,1,2.06,2.7v2.63c0,1.89-.95,3-2.77,3s-2.76-1.08-2.76-3v-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.71,308c0-1.89,1-3,2.82-3s2.81,1.08,2.81,3v6.14c0,1.89-1,3-2.81,3s-2.82-1.08-2.82-3Zm1.86,6.26c0,.84.37,1.16,1,1.16s1-.32,1-1.16v-6.38c0-.84-.37-1.16-1-1.16s-1,.32-1,1.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.39,308c0-1.89,1-3,2.82-3s2.82,1.08,2.82,3v6.14c0,1.89-1,3-2.82,3s-2.82-1.08-2.82-3Zm1.86,6.26c0,.84.37,1.16,1,1.16s1-.32,1-1.16v-6.38c0-.84-.37-1.16-1-1.16s-1,.32-1,1.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.65,312.26l-.57,1.08V317h-1.85v-11.8h1.85v5.14l2.43-5.14h1.85l-2.58,5.26,2.58,6.54h-1.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.49,
    y1: 325.22,
    x2: 363.55,
    y2: 325.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.48,
    y1: 295.11,
    x2: 190.48,
    y2: 351.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.94,
    y1: 295.11,
    x2: 300.94,
    y2: 351.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76,289.81h3.29v1h-1.12v5.8h-1.06v-5.8h-1.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.42,291.43a1.62,1.62,0,1,1,3.23,0V295a1.62,1.62,0,1,1-3.23,0Zm1.07,3.59c0,.49.21.67.55.67s.55-.18.55-.67v-3.65c0-.49-.21-.67-.55-.67s-.55.18-.55.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.34,289.81H138a1.46,1.46,0,0,1,1.59,1.67v3.43a1.46,1.46,0,0,1-1.59,1.67h-1.68Zm1.06,1v4.83h.6c.34,0,.54-.17.54-.66v-3.52c0-.48-.2-.65-.54-.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.71,296.58h-1.07l-.18-1.23h-1.31l-.18,1.23h-1l1.08-6.77h1.56Zm-2.42-2.15h1L141.8,291Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.2,294.34l-1.34-4.53H145l.81,3.08.81-3.08h1l-1.34,4.53v2.24H145.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.19,293l-.39,3.61h-1.46l-.75-6.77h1l.57,5.34.51-5.34h1l.53,5.38.55-5.38h.93l-.75,6.77h-1.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.33,292.66h1.46v1h-1.46v2h1.84v1h-2.9v-6.77h2.9v1h-1.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.89,292.66h1.46v1h-1.46v2h1.84v1h-2.9v-6.77h2.9v1h-1.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.78,293.88l-.33.62v2.08h-1.06v-6.77h1.06v2.95l1.39-2.95h1.06l-1.47,3,1.47,3.75h-1.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.29,294.62l.72-4.81h1.48v6.77h-1v-4.85l-.74,4.85h-1l-.8-4.79v4.79H340v-6.77h1.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.18,291.43a1.62,1.62,0,1,1,3.23,0V295a1.62,1.62,0,1,1-3.23,0Zm1.06,3.59c0,.49.21.67.55.67s.55-.18.55-.67v-3.65c0-.49-.21-.67-.55-.67s-.55.18-.55.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,291.68v4.9h-1v-6.77h1.34l1.09,4.05v-4.05h.95v6.77h-1.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.91,289.81h3.29v1h-1.11v5.8H354v-5.8h-1.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.72,296.58h-1.06v-6.77h1.06v2.9h1.21v-2.9H360v6.77h-1.09v-2.9h-1.21Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-107"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.3,376.62s-1.43-4.66-5.61-6.33c-2.9-1.16-6.25-.85-9.25-.33-5.61,1-10.5,3.2-15.82,5.11,0,0,2.27-.84,11.58,3.7a25.17,25.17,0,0,0,11.27,2.88C406.62,381.58,411.45,380.68,411.3,376.62Z",
    style: {
      fill: "#3FB9EA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.81,362.94s0-4.87-3.55-7.67c-2.44-1.95-5.73-2.63-8.76-3-5.65-.68-11,0-16.61.33,0,0,2.41-.15,10,6.88a25.08,25.08,0,0,0,10,6C405.9,366.34,410.78,366.87,411.81,362.94Z",
    style: {
      fill: "#3FB9EA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.43,381s-3.8-3-3.81-7.55c0-3.13,1.5-6.12,3.1-8.72,3-4.86,6.85-8.58,10.58-12.82,0,0-1.61,1.8-.83,12.13A25,25,0,0,1,429,375.61C427.76,378.51,425.15,382.66,421.43,381Z",
    style: {
      fill: "#3FB9EA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.88,388.51s-.53-4.84,2.64-8c2.2-2.22,5.39-3.27,8.35-4,5.53-1.34,10.91-1.24,16.54-1.6,0,0-2.41.13-9.15,8a25,25,0,0,1-9.2,7.13C441.14,391.2,436.36,392.29,434.88,388.51Z",
    style: {
      fill: "#3FB9EA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,371.25s-4.82-.66-7.15-4.51c-1.61-2.68-1.85-6-1.82-9.08.06-5.69,1.47-10.88,2.5-16.43,0,0-.46,2.37,5.52,10.83a24.93,24.93,0,0,1,4.65,10.66C438.14,365.84,438,370.75,434,371.25Z",
    style: {
      fill: "#3FB9EA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.89,362.59s3.47,3.41,7.94,2.9c3.11-.35,5.9-2.21,8.3-4.1,4.47-3.52,7.72-7.8,11.49-12,0,0-1.6,1.81-11.94,2.24a25.09,25.09,0,0,0-11.29,2.82C449.65,356,445.83,359.09,447.89,362.59Z",
    style: {
      fill: "#3FB9EA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.87,359.21s4.85.49,8-2.72c2.19-2.22,3.21-5.42,3.9-8.39,1.27-5.55,1.12-10.92,1.43-16.56,0,0-.11,2.42-7.91,9.23a25.24,25.24,0,0,0-7,9.28C441.12,353,440.07,357.77,443.87,359.21Z",
    style: {
      fill: "#3FB9EA"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "426.57 406.37 418.2 385.79 408.55 361.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "428.5 402.83 436.86 374.2 445.87 356.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.72,
    y1: 391.58,
    x2: 440.08,
    y2: 386.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 436.86,
    y1: 374.2,
    x2: 432.68,
    y2: 364.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.1,
    y1: 364.92,
    x2: 452.3,
    y2: 360.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 419.81,
    y1: 389.65,
    x2: 423.35,
    y2: 375.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.12,
    y1: 378.89,
    x2: 406.95,
    y2: 374.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.92 416.67 419.83 416.67 416.6 399.62 438.15 399.62 434.92 416.67",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-107"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "269.78 331.76 247.88 392.78 252.56 411.47 267.44 402.13 275.33 338.18 269.78 331.76",
    style: {
      fill: "#3FB9EA",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.63,388.11s5.84,5.55,8.18,11.39,1.46,10.22-.88,12.55-5.84,2.34-10.21,2.34S236.5,402.13,235.91,396,245,386.65,249.63,388.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.09,398s-9.92,4.67-9.05,5.55,7.59-2.34,9.05-2.63S174.31,397.45,171.09,398Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.89,394.83s-3.21-.59-3.8.87-3.21,9.35-2.92,11.1,2.92-1.75,4.09-3.51S174.89,394.83,174.89,394.83Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,394.83s-5.25-1.46-6.13,0-5.55,11.68-5.55,11.68-.58,1.16,2,0S181,394.83,181,394.83Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.8,394.83,210.51,398s-23.07-4.67-25.69-5-5.26,1.76-6.43,3.51-8.46,11.09-8.46,11.09l1.75.59,10.22-8.18s5.54-.29,7.3-.29-5,3.8-7,4.09-4.38.58-4.09,1.75,5.55,1.46,6.72,1.46,9.34-2.92,9.34-2.92,2,0,4.67.29,7.3-1.75,7.3-1.75,41.46,9.93,44.38,9.63S253.64,396.77,243.8,394.83Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.47,328.59s16.47-14.32,30.79-13.6,17.9,8.59,17.9,8.59l-12.05,93H278.87Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.6,416.67h22.56c1.43-9.11,10.48-66.27,12.36-73.52a110.43,110.43,0,0,1,5-14.6l-2-11.68s-30.66,12.85-30.66,14.89.29,1.17.29,5.26C270.07,340.8,263.57,406.85,262.6,416.67Z",
    style: {
      fill: "#3FB9EA",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.72 314.82 288.18 330.3 298.69 325.34 293.72 314.82",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.93 294.68 315.04 293.51 293.72 314.82 300.73 333.22 313.87 308.4 328.18 308.4 329.93 294.68",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.47,245.92s-6.72,4.09-7.3,14.6,1.75,37.66,3.21,42,8.76,8.76,14.31,7.59c0,0,2.33,25.7,5,25.11s16.35-19,16.93-24.23S322,288.84,322,288.84a185.5,185.5,0,0,0,2-23.94c0-10.8-2.63-19.56-12-22.78S294.89,241.25,288.47,245.92Z",
    style: {
      fill: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-107)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.12,242.12c-9.35-3.21-17.23-.87-23.65,3.8a10,10,0,0,0-1.59,1.28c.46.29,3.91,2.24,11.05,2.24,7.69,0,17.65-1.14,17.65-1.14s-4.55,4.28-4.84,7.41.86,11.11,3.42,12.53.28,4,1.71,6.27,3.42,3.41,6.26.85a9,9,0,0,0,1.66-2.46c.18-2.66.3-5.4.3-8C324.09,254.1,321.46,245.34,312.12,242.12Z",
    style: {
      fill: "#9e9e9e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M288.47,245.92s-6.72,4.09-7.3,14.6,1.75,37.66,3.21,42,8.76,8.76,14.31,7.59c0,0,2.33,25.7,5,25.11s16.35-19,16.93-24.23S322,288.84,322,288.84a185.5,185.5,0,0,0,2-23.94c0-10.8-2.63-19.56-12-22.78S294.89,241.25,288.47,245.92Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.79,278s4.67-7.3,7-5.55,1.75,10.8.29,14-3.51,4.09-4.67,1.46",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.22,275.7s-2.92,12-2,13.72,5.83,1.76,7.88.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.64,294.68s5.83,1.75,9.63-.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,277.45c0,1.29-.52,2.34-1.17,2.34s-1.16-1.05-1.16-2.34.52-2.33,1.16-2.33S301,276.16,301,277.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,276c0,1.29-.53,2.34-1.17,2.34s-1.17-1.05-1.17-2.34.52-2.33,1.17-2.33S287,274.7,287,276Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.92,271.32s2.63-2,6.42,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.35,272.2s5.84-2.92,9.64.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.52,416.67c1.25-7.33,13-76.28,13.32-78.49s1.46-6.13-.58-6.71-37.38-21.9-37.38-21.9L311.24,321s-.29,16.35-3.5,27.44c-3,10.41-8.34,61.93-9,68.27Z",
    style: {
      fill: "#3FB9EA",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.24 320.96 316.2 336.14 331.97 309.86 329.93 294.68 311.24 320.96",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.15,344.9l-11.39,40.29,16.64,20.15s14-25.7,19-43.21,5.55-27.16,2.34-29.2a50.49,50.49,0,0,0-6.72-3.51",
    style: {
      fill: "#3FB9EA",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.76,380.81s-10.51,5.26-10.8,8.47,9.05,13.14,11.38,17.52,5.55,7.88,10.51,5.84,10.22-7.59,10.22-12.56-7.3-12.55-12.55-16.06S330.51,381.1,328.76,380.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.58,396s-5.84,3.22-8.47,3.51-2.34,2.63,0,3.5,10.51-3.21,12.26-3.21,15.48,1.17,18.4,1.46,4.67-2.63-2.63-5S233.58,396,233.58,396Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.05,391.89s-5.41-1.25-6.1,1-7,11.21-7.18,12.07,2.09,1.56,4.67-1.25S240.05,391.89,240.05,391.89Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.09,390.74s-4.67-1.17-5.84,0-9.35,14.89-9.35,16.06,3.22.58,3.22.58l9.34-12.85,2.92-2.62Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.22,411.76a8,8,0,0,0,7-7.59c.58-7-7-13.72-12.27-14s-29.78,5.26-39.7,5.55-18.69.29-20.73-.58-19.27-4.38-20.44-4.38S231,407.38,231,407.38s.87,2,3.21,0,9.93-9.05,9.93-9.05h8.46s-7.88,4.67-9.05,5.55-5.84,5.84-4.67,6.13,7.3-5,7.3-5l8.76-2.34s6.42,4.09,12.26,4.38a26.66,26.66,0,0,0,10.22-1.46S311.24,412.05,330.22,411.76Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-107"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 450.76,
    y1: 416.67,
    x2: 41.53,
    y2: 416.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.23,
    y: 412.01,
    width: 126.74,
    height: 4.65,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.43,
    y: 412.01,
    width: 59.55,
    height: 4.65,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.38 412.01 177.95 353.21 104.92 353.21 134.19 412.01 201.38 412.01",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.43 412.01 175 353.21 101.96 353.21 131.23 412.01 198.43 412.01",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.0740821361541748px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.d01c2d623cd7f2eb3d5d3828e7e0741b.svg";
export { ForwardRef as ReactComponent };